<template>
  <div class="main-contaienr">
    <div class="left">
      <!-- 今日统计 -->
      <div class="statistics leftchild1">
        <cus-border title="今日统计" ref="blya1">
          <div class="statistics-group">
            <div
              class="statistics-item"
              v-for="(item, index) in statisticsList"
              :key="index"
            >
              <statistics-item :item="item"></statistics-item>
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 今日售检票 -->
      <div class="ticket leftchild1">
        <cus-border title="今日售检票" ref="blya2">
          <div class="cake-group">
            <div
              class="cake-item"
              v-for="(item, index) in ticketList.cake"
              :key="index"
            >
              <ticket-cake :item="item"></ticket-cake>
            </div>
          </div>
          <div class="progress-group">
            <div
              class="progress-item"
              v-for="(item, index) in ticketList.progress"
              :key="index"
            >
              <ticket-progress :item="item"></ticket-progress>
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 视频监控 -->
      <div class="video leftchild1">
        <cus-border title="视频监控" ref="blya3">
          <div
            class="monitor-con"
            v-loading="monitorLoading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <monitor-page
              class="monitor-box"
              ref="monitor"
              :M_list="lists"
              :topTag="false"
              :page="0"
              v-if="showMonitor"
            />
          </div>
        </cus-border>
      </div>
    </div>

    <div class="right">
      <!-- 应急事件统计 -->
      <div class="urgent rightChild">
        <cus-border title="应急事件统计" ref="blya4">
          <div class="urgent-group">
            <div
              class="urgent-item"
              v-for="(item, index) in urgentList"
              :key="index"
            >
              <urgent-item :item="item"></urgent-item>
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 停车场使用情况 -->
      <div class="parking rightChild">
        <cus-border title="停车场使用情况" ref="blya5">
          <parking :item="parking"></parking>
        </cus-border>
      </div>
      <!-- wifi综合统计 -->
      <div class="wifi-statis rightChild">
        <cus-border title="wifi综合统计" ref="blya6">
          <wifi-statis :item="wifi"></wifi-statis>
        </cus-border>
      </div>
    </div>
    <!-- 底部盒子 -->
    <div class="bottom-box">
      <bottom-box></bottom-box>
    </div>
  </div>
</template>
<script>
  // 导入地图
  // import drawnMap from '@/components/drawn-map/drawn-map'
  // 导入今日统计
  import statisticsItem from './components/statistics-item.vue'
  // 导入今日售检票
  import ticketCake from './components/ticket-cake.vue'
  import ticketProgress from './components/ticket-progress.vue'
  // 导入应急事件统计
  import urgentItem from './components/urgent-item.vue'
  // 导入停车场使用情况
  import parking from './components/parking.vue'
  // 导入WiFi综合统计
  import wifiStatis from './components/wifi-statis.vue'
  // 底部盒子
  import bottomBox from './components/bottom-box.vue'
  // 监控
  import monitorPage from '../monitor/components/monitorPage.vue'
  import { getVideoList } from '@/api/video'
  export default {
    components: {
      statisticsItem,
      urgentItem,
      ticketCake,
      ticketProgress,
      parking,
      wifiStatis,
      bottomBox,
      monitorPage,
      // drawnMap,
    },
    data() {
      return {
        // 今日统计
        statisticsList: [
          {
            num: '345',
            name: '已停车次',
            fileName: 'statistics1',
            iconWidth: '1.8975vw',
          },
          {
            num: '143,50',
            name: '入园人数',
            fileName: 'statistics2',
            iconWidth: '1.5625vw',
          },
          {
            num: '124,540',
            name: '售票数量',
            fileName: 'statistics3',
            iconWidth: '1.5625vw',
          },
        ],
        // 今日检票
        ticketList: {
          cake: [
            {
              total: 874,
              number: 586,
              name: '线下已检票',
              color: ['#4598FD', '#0D76F9'],
              dashed: '#02FFA3',
            },
            {
              total: 705,
              number: 254,
              name: '线上已检票',
              color: ['#24EF88', '#03B55B'],
              dashed: '#FFCC02',
            },
          ],
          progress: [
            {
              name: '应入园线下票',
              total: 12000,
              number: 9560,
              color: ['#0A3124', '#02FFA3'],
            },
            {
              name: '应入园线上票',
              total: 1000,
              number: 560,
              color: ['#123C40', '#00F6FF'],
            },
          ],
        },
        // 应急事件统计
        urgentList: [
          {
            num: '46',
            name: '已处理事件',
            fileName: 'urgent1',
          },
          {
            num: '29',
            name: '未处理事件',
            fileName: 'urgent2',
          },
          {
            num: '19',
            name: '本月事件',
            fileName: 'urgent3',
          },
          {
            num: '945',
            name: '本年事件',
            fileName: 'urgent4',
          },
        ],
        // 停车场使用情况
        parking: {
          ratioNumber: 1520,
          ratioTotal: 3424,
          xData: [
            '01时',
            '02时',
            '03时',
            '04时',
            '05时',
            '06时',
            '07时',
            '08时',
          ],
          val: [220, 55, 191, 10, 150, 330, 110, 125],
        },
        // wifi综合统计
        wifi: {
          total: 775,
          number: 248,
        },
        lists: [
          // {
          //   name: '117ea0a854254faf8737e40ea0c7fa0d',
          //   title: '安居尔花苑大门外',
          //   site: 1,
          //   id: 1,
          // },
        ],
        showMonitor: false,
        monitorLoading: true,
      }
    },
    mounted() {
      this.init()
      window.addEventListener('resize', () => this.measure1(), false)
    },
    created() {
      this.getmonitorList()
    },
    watch: {
      monitorLoading(v) {
        this.showMonitor = !v
      },
    },
    beforeDestroy() {
      this.$animejs.remove(['.svg-container', '.leftchild1', '.rightChild'])
      window.removeEventListener('resize', this.measure1(), false)
      this.showMonitor = false
    },
    methods: {
      getmonitorList() {
        getVideoList({ scenic_spot_id: 45, page: 1, limit: 1 }).then((res) => {
          const { data } = res
          this.lists = data.rows
          this.$store.dispatch('map/setMonitor', data.rows)
        })
      },
      init() {
        let anime = this.$animejs
        anime({
          targets: '.svg-container',
          boxShadow: [
            {
              value: '0 0 6px 6px rgba(255,255,255,.2)',
              easing: 'easeOutSine',
              duration: 1000,
            },
            {
              value: '0 0 0 0 rgba(255,255,255,.2)',
              easing: 'easeInOutQuad',
              duration: 1500,
            },
          ],
          delay: anime.stagger(300, { grid: [14, 5], from: 'center' }),
        })
        anime({
          targets: '.leftchild1',
          translateX: [-600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(300),
        })
        anime({
          targets: '.rightChild',
          translateX: [600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(300),
        })
        setTimeout(() => {
          this.monitorLoading = false
        }, 2000)
      },
      measure1() {
        this.$refs.blya1.init()
        this.$refs.blya2.init()
        this.$refs.blya3.init()
        this.$refs.blya4.init()
        this.$refs.blya5.init()
        this.$refs.blya6.init()
      },
    },
  }
</script>
<style lang="scss" scoped>
  .main-contaienr {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 100%;
    .left,
    .right {
      width: 23.59375vw;
      position: relative;
      z-index: 3;
      // 今日统计
      .statistics {
        height: 26vh;
        overflow: hidden;
        .statistics-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .statistics-item {
            width: 28%;
          }
        }
      }
      // 今日检票
      .ticket {
        height: 34vh;
        margin: 1.5vh 0;
        .cake-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          .cake-item {
            width: 50%;
            margin-bottom: 1vh;
          }
        }
        .progress-group {
          .progress-item {
            padding-top: 1vh;
          }
        }
      }
      // 视频
      .video {
        height: 22.4vh;
        video {
          height: 8vh;
          width: 100%;
        }
      }
      // 应急事件统计
      .urgent {
        height: 22vh;
        overflow: hidden;
        .urgent-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .urgent-item {
            width: 23%;
          }
        }
      }
      // 停车场使用情况
      .parking {
        height: 32.5vh;
        margin: 1.5vh 0;
      }
      // wifi综合统计
      .wifi-statis {
        height: 28vh;
      }
    }
    .center {
      flex-grow: 1;
      color: transparent;
    }
  }
  .bottom-box {
    position: fixed;
    bottom: 0;
    left: 50%;
    margin-left: -19.375vw;
    z-index: 222;
    width: 48%;
  }
  .monitor-con {
    height: 68%;
  }
  .monitor-box {
    height: 23vh;
    margin-top: -2.5vh;
  }
</style>
